import { FC, ChangeEvent } from 'react';

import { Moment } from '@tools/utils';

import './index.scss';

interface Props {
    end: string;
    start: string;
    endLabel: string;
    startLabel: string;
    disabled?: boolean;
    onEndChange: (value: string) => void;
    onStartChange: (value: string) => void;
}

interface TimePickerProps {
    label?: string;
    value: string;
    action: (value: string) => void;
}

export const TimePicker: FC<Readonly<TimePickerProps>> = ({
    value,
    action,
    label,
}: TimePickerProps) => {
    const time = Moment().startOf('day');

    return (
        <>
            {label}
            <select
                value={value}
                onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                    action(e.target.value)
                }
                className="c-time-picker"
            >
                {Array(24 * 4)
                    .fill(0)
                    .map((_, i) => {
                        const value = time
                            .add(i === 0 ? 0 : 15, 'minutes')
                            .format('HH:mm');
                        return (
                            <option key={i} value={value.replace(':', '')}>
                                {value}
                            </option>
                        );
                    })}
            </select>
        </>
    );
};

export const TimeRangePicker: FC<Readonly<Props>> = ({
    end,
    start,
    endLabel,
    disabled,
    startLabel,
    onEndChange,
    onStartChange,
}) => {
    return (
        <ul className={disabled ? 'disabled' : ''}>
            <li>
                <TimePicker
                    label={startLabel}
                    value={start}
                    action={onStartChange}
                />
            </li>

            <li>
                <TimePicker label={endLabel} value={end} action={onEndChange} />
            </li>
        </ul>
    );
};

export default TimeRangePicker;
